import {useInvalidateQueryCache} from '@aboutyou/data-fetcher';
import {WalletService_GetWalletLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.grpc.lazy';
import {useCallback} from 'react';

export const useInvalidateGetWallet = () => {
  const {invalidateRequests} = useInvalidateQueryCache();

  return useCallback(() => {
    invalidateRequests([WalletService_GetWalletLazy.method]);
  }, [invalidateRequests]);
};
